import { type ComputedRef, type InjectionKey, type Ref } from 'vue';
import { type Event, type Tag } from '@views/Event/EventTypes';
import { type QueueEventProperty, type SaveEventProperty, type SaveEventPropertyIfChanged } from '@views/Event/EventEditor/use-event-property-saves';

/** Provided by EventEditorRoot to every page of the event editor. */
export const eventKey: InjectionKey<ComputedRef<Event | null>> = Symbol('event');
/** The user has Write access on the event (ACL), regardless of its status. */
export const canWriteKey: InjectionKey<Readonly<Ref<boolean>>> = Symbol('canWrite');
/** canWrite and the event is unlocked for editing (not Active, or Active and explicitly unlocked). */
export const canEditKey: InjectionKey<Readonly<Ref<boolean>>> = Symbol('canEdit');
export const saveEventPropertyKey: InjectionKey<SaveEventProperty> = Symbol('saveEventProperty');
export const saveEventPropertyIfChangedKey: InjectionKey<SaveEventPropertyIfChanged> = Symbol('saveEventPropertyIfChanged');
export const queueEventPropertyKey: InjectionKey<QueueEventProperty> = Symbol('queueEventProperty');
export const saveEventTagsKey: InjectionKey<(tags: Tag[]) => Promise<void>> = Symbol('saveEventTags');
/** Lets children with their own save calls drive the shared saving indicator. */
export const trackSaveKey: InjectionKey<<T>(work: () => Promise<T>) => Promise<T>> = Symbol('trackSave');
